import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { DatePicker } from '../../../../../../components/ClickableField/ClickableField';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { SlideTransition } from '../../../../../../components/Transition/Transition';
import _ from 'lodash';
import moment from 'moment';
import { updateAdviserBusiness } from '../../../../../../store/adviserDashboard/duck';

const QuarterEndDateDialog = props => {
  const { intl, adviserBusiness, onClose, updateAdviserBusiness, ...rest } = props;

  const abQuarterEndDate = _.get(adviserBusiness, 'quarterEndDate');
  const abBigDate = _.get(adviserBusiness, 'bigDate');
  const [quarterEndDate, setQuarterEndDate] = useState(abQuarterEndDate ? moment.parseZone(abQuarterEndDate) : null);
  const [bigDate, setBigDate] = useState(abBigDate ? moment.parseZone(abBigDate) : null);

  const currentMonth = parseInt(moment().format('MM'));
  const month = currentMonth <= 3 ? 3 : currentMonth <= 6 ? 6 : currentMonth <= 9 ? 9 : currentMonth <= 12 ? 12 : 12;
  const today = new Date();
  const year = today.getFullYear();
  const day = 0;
  const minDate = moment(today).add(1, 'days');
  const maxDate = moment(new Date(year, month, day));

  const onChangeQuarterEndDate = date => {
    if (date) {
      const qdate = date ? moment(date).format('YYYY-MM-DD') : null;
      const qdate1 = date ? moment.utc(qdate).format('YYYY-MM-DDT00:00:00.00Z') : null;
      setQuarterEndDate(qdate1);
    } else {
      setQuarterEndDate(null);
    }
  };

  const onChangeBigDate = date => {
    if (date) {
      const d = date ? moment(date).format('YYYY-MM-DD') : null;
      const date1 = d ? moment.utc(d).format('YYYY-MM-DDT00:00:00.00Z') : null;
      setBigDate(date1);
    } else {
      setBigDate(null);
    }
  };

  const updateQuarterDate = () => {
    updateAdviserBusiness({ quarterEndDate, bigDate });
    onClose();
  };

  useEffect(() => {
    setQuarterEndDate(abQuarterEndDate ? moment.parseZone(abQuarterEndDate) : null);
    setBigDate(abBigDate ? moment.parseZone(abBigDate) : null);
  }, [adviserBusiness]);

  return (
    <Dialog
      fullWidth={true}
      keepMounted
      onClose={onClose}
      {...rest}
      slots={{
        transition: SlideTransition
      }}>
      <DialogTitle> {intl.formatMessage({ id: 'Date Setting' })}</DialogTitle>
      <DialogContent>
        <DialogContentText>{intl.formatMessage({ id: 'dateSetting_desc' })}</DialogContentText>
        <div className="caseclose-form">
          <div className="form-group" style={{ marginBottom: '-15px' }}>
            <div className="col-md-6 col-xs-6 text-right adv_biz_modal_key padding__left-0">
              <label className="control-label adv_biz_modal_key">{intl.formatMessage({ id: 'Quarter End' })} :</label>
            </div>
            <div className="col-md-6 col-xs-6 text-left adv_biz_modal_key">
              <div className="modal-text">
                <DatePicker
                  name="quarterEndDate"
                  format="DD-MMM-YYYY"
                  className="case-datepicker close-case-date case-open-datepicker input__spacing qEnd--Date"
                  minDate={minDate}
                  maxDate={maxDate}
                  value={quarterEndDate ? moment(quarterEndDate) : null}
                  onChange={onChangeQuarterEndDate}
                  slotProps={{ field: { clearable: true } }}
                />
              </div>
            </div>
          </div>
          <div className="form-group" style={{ marginBottom: '0px' }}>
            <div className="col-md-6 col-xs-6 text-right adv_biz_modal_key">
              <label className="control-label adv_biz_modal_key">{intl.formatMessage({ id: 'Big Date' })} :</label>
            </div>
            <div className="col-md-6 col-xs-6 text-left adv_biz_modal_key">
              <div className="modal-text">
                <DatePicker
                  name="bigDate"
                  format="DD-MMM-YYYY"
                  className="case-datepicker close-case-date case-open-datepicker input__spacing qEnd--Date"
                  value={bigDate ? moment(bigDate) : null}
                  onChange={onChangeBigDate}
                  slotProps={{ field: { clearable: true } }}
                />
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {intl.formatMessage({ id: 'Close' })}
        </Button>
        <Button onClick={updateQuarterDate} color="primary">
          {intl.formatMessage({ id: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const container = connect(
  state => ({
    adviserBusiness: state.adviserDashboard.adviserBusiness
  }),
  {
    updateAdviserBusiness
  }
)(QuarterEndDateDialog);

export default injectIntl(container);
